<template>
  <main class="contact-us-page " role="main" >
    <div class="row ">
      <div class="col-sm-12  help-section">
        <div class="container">
          <p class="section-title help">HELP</p>
          <p class="text-normal">
            We are eager to help you with any of your queries. Contact us how you want to, using the info below.
          </p>
          <div class="help-details-container">
            <div class="col col-12">
              <div class="row">
                <div class="col col-xs-12">
                  <label>Email Us</label>
                </div>
                <div class="col col-xs-12">
                  <a href="mailto:support@meandyoumobile.co.za">support@meandyoumobile.co.za</a>
                </div>
              </div>
            </div>

            <div class="col col-12 ">
              <div class="row">
                <div class="col col-xs-12 ">
                  <label>Call Us</label>
                </div>
                <div class="col right col-xs-12">
                  <a href="tel:+27861333110">086 133 3110</a>
                </div>
              </div>
            </div>

            <!-- <div class="col col-12">
              <div class="row">
                <div class="col col-xs-12">
                  <label>Live Chat</label>
                </div>
                <div class="col right col-xs-12">
                    <a class="point"  v-on:click="liveChat()">Live Chat</a>
                </div>
              </div>
            </div> -->

            <!-- <div class="col col-12">
              <div class="row">
                <div class="col col-xs-12">
                  <label>Call me back</label>
                </div>
                <div class="col right col-xs-12">
                   <a class="point"  data-toggle="modal" data-target="#callMeBackModal">Call Me Back </a>
                </div>
              </div>
            </div> -->
            
          </div>
        </div>
      </div>      
    </div>
  </main>
</template>

<script>
//import Zendesk from '@/components/elements/vue-zendesk.vue';

export default {
  name: "contact-us",
    methods: {
    // liveChat: function () {
    //   Zendesk.toggleChatWindow();
    // }
  }
};
</script>

<style lang="scss">
  .interact {
    a {
      cursor: pointer;
    }
  }
</style>


